import { underscore } from '@ember/string';

export const uiPageConfig = {
  contentType: 'static_block',
  locationField: 'field_static_block_location',
  // Transform ui location references for back-end (default: converts dashes to underscores)
  locationTransform: location => underscore(location),
  // Alias ui page locations
  locations: {
    // (e.g. 'local-ui-location': 'remote_ui_location')
  },
  defaultHoursCached: 24,
  hoursCached: {
    // (e.g. 'home': 48)
  },
};

export default uiPageConfig;
